import { useState } from "react";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useContextUsuarios } from "src/Contexts/Usuarios/UsuariosContext";
import { api } from "src/shared/setup/API/api";

interface IUseFormFilial {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const UseFormFilial = ({ setOpenModal }: IUseFormFilial) => {
  const { setAttTable, id } = useConfigPageContext();
  const { valuesInputsFiliais } = useContextUsuarios();
  const { handleGetAlert } = useLayoutMainContext();

  const [loading, setLoading] = useState(false);

  const handleCreate = async () => {
    if (!valuesInputsFiliais.filial)
      return handleGetAlert({ message: `Digite uma filial` });

    setLoading(true);

    const AllDatas = { ...valuesInputsFiliais };

    return api
      .post("/createFiliais", AllDatas)
      .then((res) => {
        setAttTable((item) => !item);
        handleGetAlert({ message: res.data.message });
        setOpenModal(false);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  const handleEdit = () => {
    if (!valuesInputsFiliais.filial)
      return handleGetAlert({ message: `Digite uma filial` });

    setLoading(true);

    const AllDatas = { ...valuesInputsFiliais };

    return api
      .put(`/updateFiliais/${id}`, AllDatas)
      .then((res) => {
        setAttTable((item) => !item);
        handleGetAlert({ message: res.data.message });
        setOpenModal(false);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmit = () => {
    if (id) {
      handleEdit();
    } else {
      handleCreate();
    }
  };

  return { handleSubmit, loading };
};
